import React from 'react';
import { ScatterChart } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface ScatterChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const ScatterChartIcon: React.FC<ScatterChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <ScatterChart size={size} color={color} />
        </IconWrapper>
    );
};
